<div class="store-filters">
  <div class="store-filters__search">
    <label class="store-filters__search-label" for="storeSearch">
      {{ 'clicStore.searchProducts' | translate }}
    </label>
    <div class="store-filters__input-box">
      <img class="store-filters__icon" src="assets/images/magnifying-glass.svg" alt="">
      <input id="storeSearch" type="search" maxlength="50"
        [placeholder]="'clicStore.searchPlaceholder' | translate" [ngModel]="term"
        (ngModelChange)="termChange.emit($event)">
      <button type="button" class="store-filters__clear" *ngIf="term"
        (click)="termChange.emit('')" [attr.aria-label]="'clicStore.clearSearch' | translate">
        &times;
      </button>
    </div>
  </div>

  <div class="store-filters__row">
    <ul class="store-filters__chips" *ngIf="showCategories">
      <li>
        <button type="button" class="store-filters__chip"
          [class.store-filters__chip--on]="!selectedCategoryKey"
          [attr.aria-pressed]="!selectedCategoryKey" (click)="categoryChange.emit(null)">
          {{ 'clicStore.allCategories' | translate }}
        </button>
      </li>
      <li *ngFor="let category of categories">
        <button type="button" class="store-filters__chip" [title]="category.label"
          [class.store-filters__chip--on]="selectedCategoryKey === category.key"
          [attr.aria-pressed]="selectedCategoryKey === category.key"
          (click)="categoryChange.emit(category.key)">
          {{ category.label }} ({{ category.count }})
        </button>
      </li>
    </ul>

    <div class="store-filters__sort">
      <span class="store-filters__count">
        {{ 'clicStore.productsCount' | translate:{ count: totalCount } }}
      </span>
      <label for="storeSort">{{ 'clicStore.sortBy' | translate }}</label>
      <select id="storeSort" [ngModel]="sort" (ngModelChange)="sortChange.emit($event)">
        <option *ngFor="let option of sortOptions" [value]="option.key">
          {{ option.label | translate }}
        </option>
      </select>
    </div>
  </div>
</div>
